
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/visa",
      function () {
        return require("private-next-pages/visitor/visa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/visa"])
      });
    }
  